import {i18n} from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: i18n.t('label.wallet_settlement_blacklist.id'),
        sortable: true,
        width: 100,
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'name',
        title: i18n.t('label.wallet_settlement_blacklist.forbidden_keywords_title'),
        sortable: true,
        width: 100,
        template: function (row) {
            return `<span class="badge badge-secondary font-weight-bold">${row.name}</span>`
        }
    },
    {
        field: 'slug',
        title: i18n.t('label.wallet_settlement_blacklist.forbidden_keywords_slug'),
        sortable: true,
        width: 100,
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        width: 100,
    },
    {
        field: 'updated_at',
        title: i18n.t('label.updated_at'),
        sortable: true,
        width: 100,
    }
]
